import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AvailabilityFilters } from '~/utilities/constants';

export interface SearchFiltersState {
  availability: AvailabilityFilters;
}

const initialState: SearchFiltersState = {
  availability: AvailabilityFilters.All,
};

export const searchFiltersSlice = createSlice({
  name: 'searchFilters',
  initialState,
  reducers: {
    setAvailability: (state, action: PayloadAction<AvailabilityFilters>) => {
      state.availability = action.payload;
    },
  },
});

type SliceState = { searchFilters: SearchFiltersState };
export const selectAvailability = (state: SliceState) =>
  state.searchFilters.availability;
export const { setAvailability } = searchFiltersSlice.actions;
export default searchFiltersSlice.reducer;
